<template>
  <b-container fluid>
    <h3>Sales Summary</h3>
    <b-row class="justify-content-md-center">
      <b-col class="my-2" cols=8>
          <b-form @submit="search">
            <b-form-row class="align-items-center mb-2">
              <b-col cols=2>
                <label>Item Num (exact only)</label>
              </b-col>
              <b-col>
                <input type="text" v-model="num" class='form-control mb-2 ml-1 mr-2 mb-sm-0' onfocus="this.select();" onmouseup="return false;" />
              </b-col>
              <b-col cols=10 />
            </b-form-row>
            <b-form-row>
              <b-col cols=2>
                <label>Start Date</label>
              </b-col>
              <b-col>
                <b-input v-model="startDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
              </b-col>
              <b-col class="pl-3" cols=2>
                <label>End Date</label>
              </b-col>
              <b-col>
                <b-input v-model="endDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
              </b-col>
              <b-col  class='text-center'>
                <b-button variant="primary" type="submit">Search</b-button>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-form-radio-group @change="search" v-model="showOption" :options="['Quantity', 'Sales($)']" />
            </b-form-row>
          </b-form>
      </b-col>
    </b-row>
    <hr />
    <sales-notes :last-reset-date="lastResetDate" :earliest-so-date="earliestSoDate" :kit="kit" :has-results="hasResults" />
    <section v-if="!kit && hasResults" class="big-text">
      <b-row v-if="productNum != '' && partNum != ''" class="justify-content-md-center align-items-center">
        <b-col cols=6>
          <div v-if="(productNum == '' || typeof(productNum) === 'undefined')">
            <b-row class="text-left">
              <b-col>
                <span><strong>Num</strong>: {{partNum}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>Description</strong>: {{partDesc}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>UOM</strong>: {{uom}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>Product Price</strong>: --</span>
              </b-col>
            </b-row>
            <b-row class="text-left" v-if="!!partAvgCost">
              <b-col>
                <span><strong>Part Avg. Cost</strong>: {{partAvgCost | formatDollars}}</span>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-row class="text-left">
              <b-col>
                <span><strong>Num</strong>: {{productNum}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>Description</strong>: {{productDesc}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>UOM</strong>: {{uom}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <span><strong>Product Price</strong>: {{productPrice | formatDollars}}</span>
              </b-col>
            </b-row>
            <b-row class="text-left" v-if="!!partAvgCost">
              <b-col>
                <span><strong>Part Avg. Cost</strong>: {{partAvgCost | formatDollars}}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols=3>
          <b-row class="text-right">
            <b-col>
              <span><strong>Available for Sale</strong>: {{avail}}</span>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col>
              <span><strong>Net Available</strong>: {{netAvail}}</span>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col>
              <span><strong>Reorder Point</strong>: {{reorderPoint}}</span>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col>
              <span><strong>Order Upto</strong>: {{orderUpto}}</span>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col>
              <span><strong>Open POs</strong>: <span v-for="po in openPos" :key="po.poid">
                <router-link :to="{ name: 'PO Report', query: { 'num': po.ponum } }" target="_blank">{{ po.ponum }}</router-link> ({{ po.status }}) - {{ po.qtyFulfilled }} / {{ po.qtyToFulfill }} Fulfilled<br/>
              </span></span>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col>
              <span><strong>Part Status</strong>:</span>{{ partStatus }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
    <hr />
    <section>
      <b-row class='justify-content-md-center align-items-center text-center'>
        <b-col cols="7" />
        <b-col cols="2">
          <b-modal id='modal' centered scrollable hide-footer title="More Info" size="lg">
            Not very.<br/><br/>
            The below numbers are assuming that we sold every item in the given timespan (quarter, year, season) TODAY, at full MSRP.<br/><br/>
            It just subtracts the <em>current</em> average part cost from the <em>current</em> product price and multiplies by <em>historic</em> sales calculations.<br/><br/>
            It does not count in pricing changes over the years, KIT pricing, sales, distributor discounts, quantity discounts, special pricing, etc.,
            and it also does not consider that costs may (and likely) have changed, and because of the way that all of those numbers are potentially inaccurate,
            this guess magnifies the potential error exponentially.
            <!--
              the developer was directly told to put this number in, this information and the button were the compromise,
              because they really, really don't like how inaccurate this number could be
            -->
          </b-modal>
          <b-row class='justify-content-md-center align-items-center text-center'>
            <span>
              How accurate is this guess?
              <b-button size="sm" variant="link" class="px-0" v-b-modal.modal>
                <i class="fas fa-question-circle"></i>
              </b-button>
            </span>
          </b-row>
          <b-row class='justify-content-md-center align-items-center text-center'>
            <b-btn @click="showSimulatedProfit" :disabled="this.inactive">{{ showingSimulatedProfit ? 'Hide' : 'Show' }} "Simulated Profit"</b-btn>
          </b-row>
        </b-col>
      </b-row>
      <b-row class='my-2 justify-content-md-center align-items-center text-center'>
        <b-col cols=6>
          <b-table :fields=quarterColumns :items=quarterTable :busy=loading class="bold-footer">
            <template slot="table-busy">
              <center>
                <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="align-middle" />
              </center>
            </template>
            <template slot="Q1" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.Q1 }}
              </div>
              <div v-else>
                {{row.item.Q1 | formatDollars}}
              </div>
            </template>
            <template slot="Q2" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.Q2 }}
              </div>
              <div v-else>
                {{row.item.Q2 | formatDollars}}
              </div>
            </template>
            <template slot="Q3" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.Q3 }}
              </div>
              <div v-else>
                {{row.item.Q3 | formatDollars}}
              </div>
            </template>
            <template slot="Q4" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.Q4 }}
              </div>
              <div v-else>
                {{row.item.Q4 | formatDollars}}
              </div>
            </template>
            <template slot="total" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.total }}
              </div>
              <div v-else>
                {{row.item.total | formatDollars}}
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col cols=1 v-if="showingSimulatedProfit" />
        <b-col cols=2 v-if="showingSimulatedProfit">
          <table class="table b-table">
            <thead>
              <th>"Simulated Profit"</th>
            </thead>
            <tbody>
              <tr v-for="row in simulatedProfitQuarterTable">
                <td> {{ (productPrice - partAvgCost) * row.total | formatDollars }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row class='my-2 justify-content-md-center align-items-center text-center'>
        <b-col cols=6>
          <b-table :fields=seasonColumns :items=seasonTable :busy=loading class="bold-footer">
            <template slot="table-busy">
              Loading...
            </template>
            <template slot="FTC" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.FTC }}
              </div>
              <div v-else>
                {{row.item.FTC | formatDollars}}
              </div>
            </template>
            <template slot="FRC" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.FRC }}
              </div>
              <div v-else>
                {{row.item.FRC | formatDollars}}
              </div>
            </template>
            <template slot="Summer" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.Summer }}
              </div>
              <div v-else>
                {{row.item.Summer | formatDollars}}
              </div>
            </template>
            <template slot="total" slot-scope="row">
              <div v-if='showOption=="Quantity"'>
                {{row.item.total }}
              </div>
              <div v-else>
                {{row.item.total | formatDollars}}
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col cols=1 v-if="showingSimulatedProfit" />
        <b-col cols=2 v-if="showingSimulatedProfit">
          <table class="table b-table">
            <thead>
              <th>"Simulated Profit"</th>
            </thead>
            <tbody>
              <tr v-for="row in simulatedProfitSeasonTable">
                <td> {{ (productPrice - partAvgCost) * row.total | formatDollars }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </section>
  </b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import NiceDate from '../utility/NiceDate';
import SalesNotes from './SalesNotes.vue'
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
    FingerprintSpinner,
    SalesNotes,
  },
  data() {
    return {
      num: '',
      startDate: moment("0101" + String(moment().year() - 4),"MMDDYYYY").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      showOption: 'Quantity',
      hasResults: true,
      loading: false,

      inactive: false,
      partNum: '',
      partDesc: '',
      productNum: '',
      productDesc: '',
      uom: '',
      partStatus: '',
      partAvgCost: undefined,
      productPrice: undefined,
      openPos: [],
      avail: 0,
      netAvail: 0,
      reorderPoint: 0,
      orderUpto: 0,
      kit: false,

      showingSimulatedProfit: false,
      simulatedProfitQuarterTable: [],
      simulatedProfitSeasonTable: [],

      quarterColumns: [
        { key: 'year', sortable: true },
        { key: 'Q1', label: 'Q1 / Mar31', sortable: true },
        { key: 'Q2', label: 'Q2 / June 30', sortable: true },
        { key: 'Q3', label: 'Q3 / Sept 30', sortable: true },
        { key: 'Q4', label: 'Q4 / Dec 31', sortable: true },
        { key: 'total', label: "Annual Total", sortable: true },
      ],
      quarterTable: [],
      seasonColumns: [
        { key: 'year', sortable: true },
        { key: 'FRC', label: 'FRC / Dec - Mar', sortable: true },
        { key: 'Summer', label: 'Summer / Apr - Jul', sortable: true },
        { key: 'FTC', label: 'FTC / Aug - Nov', sortable: true },
        { key: 'total', label: "Program Year Total", sortable: true },
      ],
      seasonTable: [],
      lastResetDate: '',
      earliestSoDate: '',
    };
  },
  mounted() {
    axios.get(`${BASE_API}/inventory-sales-history/config-stats`).then(response => {
      this.lastResetDate = response.data.find(x => x.field == 'last_reset_date').data;
      this.earliestSoDate = response.data.find(x => x.field == 'earliest_so_date').data;
    }).catch((error) => {
      console.error(error);
    });
  },
  methods: {
    checkKit() {
      this.kit = false;
      axios({
        method: 'post',
        url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
        data: {
          exactMatch: true,
          productNum: this.num
        }
      }).then(response => {
        if (response.data.length > 0) {
          this.kit = response.data[0].item_type == 'Kit';
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    search(event) {
      let option = this.showOption;
      if (typeof(event) == "object") { event.preventDefault(); }
      else { option = event; }
      if (this.num == '') return;
      this.loading = true;
      this.hasResults = true;

      this.checkKit();
      axios.all([
        axios.get(`${BASE_API}/inventory-sales-history/sales-summary?num=${this.num}&start=${this.startDate}&end=${this.endDate}&option=${option}`),
        axios.get(`${BASE_API}/fishbowl/parts/reorder/${this.num}`),
        axios.get(`${BASE_API}/inventory-sales-history/sales-summary?num=${this.num}&start=${this.startDate}&end=${this.endDate}&option=Quantity`)
      ]).then(axios.spread((sales, reorder, simRevenue) => {
        if (!sales.data.partNum && !sales.data.productNum) {
          this.hasResults = false;
          return;
        }

        this.inactive = sales.data.fbAvailableForSale == null
        if (this.inactive) {
          this.showingSimulatedProfit = false
          this.avail = '0 (inactive!)'
          this.netAvail = '0 (inactive!)'
        } else {
          this.avail = sales.data.fbAvailableForSale
          this.netAvail = sales.data.fbAvailableForSale - sales.data.neededInParents - sales.data.inSoEstimates
        }
        this.partNum = sales.data.partNum
        this.partDesc = sales.data.partDesc
        this.productNum = sales.data.productNum
        this.productDesc = sales.data.productDesc
        this.partStatus = sales.data.partStatus
        this.partAvgCost = sales.data.partAvgCost
        this.productPrice = sales.data.productPrice
        this.openPos = sales.data.partPos

        if (!!reorder.data) {
          this.reorderPoint = Number(reorder.data.reorderPoint)
          this.orderUpto = Number(reorder.data.orderUpToLevel)
        }

        if (!sales.data) {
          this.uom = "";
          this.quarterTable = [ ];
          this.seasonTable = [ ];
          this.simulatedProfitQuarterTable = [];
          this.simulatedProfitSeasonTable = []
        } else {
          this.uom = sales.data.uom,
          this.quarterTable = sales.data.tables.quarter_table;
          this.seasonTable = sales.data.tables.season_table;
          this.simulatedProfitQuarterTable = simRevenue.data.tables.quarter_table
          this.simulatedProfitSeasonTable = simRevenue.data.tables.season_table
        }
        this.loading = false;
      })).catch(error => {
        console.error(error)
      })
    },
    showSimulatedProfit(event) {
      if (event) event.preventDefault();

      this.showingSimulatedProfit = !this.showingSimulatedProfit
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/purchasing/SalesSummary.vue